import { FNO_BAN, FNO_BAN_CLEAR_MSG, FNO_BAN_ERROR, FNO_BAN_HIDE_ERROR, FNO_BAN_MSG, FNO_BAN_START_LOADER, FNO_BAN_STOP_LOADER, } from "../interface/iFnoBan";
const initialState = {
    data: {
        securities: {
            stockList: [],
            asOnDate: "",
        },
        possibleEntrance: {
            stockList: [],
            asOnDate: "",
        },
        possibleExits: {
            stockList: [],
            asOnDate: "",
        },
    },
    securitiesMessage: {
        msg: null,
        show: false,
        icon: null,
    },
    possibleEntranceMassage: {
        msg: null,
        show: false,
        icon: null,
    },
    possibleExitsMessage: {
        msg: null,
        show: false,
        icon: null,
    },
    fnoBanLoader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const fnoBan = (state = initialState, action) => {
    switch (action.type) {
        case FNO_BAN:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case FNO_BAN_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case FNO_BAN_MSG:
            return Object.assign(Object.assign({}, state), { [action.errorMsg]: action.payload.message });
        case FNO_BAN_CLEAR_MSG:
            return Object.assign(Object.assign({}, state), { [action.errorMsg]: initialState[action.errorMsg] });
        case FNO_BAN_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initialState.errorData });
        case FNO_BAN_START_LOADER:
            return Object.assign(Object.assign({}, state), { fnoBanLoader: true });
        case FNO_BAN_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { fnoBanLoader: false });
        default:
            return Object.assign({}, state);
    }
};
export default fnoBan;
